var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled)?_c('div',{staticClass:"ck-content",staticStyle:{"opacity":"0.6"},domProps:{"innerHTML":_vm._s(_vm.value)}}):_c('ckeditor',{ref:"myeditor",attrs:{"editor":_vm.editor,"value":_vm.value||'',"config":_vm.editorConfig},on:{"input":val => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }